import CRUDService from 'src/services/CRUDService';

export interface ReportDownloadEvent {
  _id: string;
  educationPhase: string;
  reportType: string;
  universityId: string;
  userEmail: string;
  createdAt: string;
}

export default new CRUDService<ReportDownloadEvent>('/v1/report-download-events');
